import React from 'react';
import GreenCard from './../../../graphics/elements/greenCard.svg';
//import SuccerBall from "./../../../graphics/elements/succerBall.png";
import GoalGate from './../../../graphics/elements/goalGate.png';

import styles from './MatchSum.module.css';
import FuncModal from '../../../partials/FuncModal';
import { apiRemoveGoal } from '../../../api/apiRemoveGoal';
import { getRoundMatches } from '../../../api/getRoundMatches';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';

function MatchSum(props) {
  const { match, setMatches } = props;
  const { leagueId, roundId, matchId } = useParams();

  const [deletedGoal, setDeletedGoal] = React.useState(null);

  const teamName = id => {
    return match.teams.filter(team => team.id === id)[0].name;
  };

  const showPlayerName = (goal, player) => {
    if (player) return player.user.full_name;
    if (goal.type === 'SELF') return 'שער עצמי';
    if (player === null) return 'שחקן אנונימי';
    return '---';
  };

  const handleDeleteGoal = async () => {
    // delete goal api
    const res = await apiRemoveGoal(leagueId, roundId, matchId, deletedGoal.id);
    if (!res.error) {
      // get the new matches and set it
      const res2 = await getRoundMatches(leagueId, roundId);
      if (!res2.error) {
        setMatches(res2);
      }
      // close the modal
      setDeletedGoal(null);

      //window.location.reload(false);
    }
  };

  const handleShowDeleteGoalModal = goalId => {
    setDeletedGoal(goalId);
  };

  const handleCloseDeleteGoalModal = () => {
    setDeletedGoal(null);
  };

  return (
    <div className={styles.matchSum}>
      <h3>
        <span>שערי המשחק: </span>
        <span>
          {match.teams[0].goals === undefined ? '0' : match.teams[0].goals}
        </span>
        <span> : </span>
        <span>
          {match.teams[1].goals === undefined ? '0' : match.teams[1].goals}
        </span>
      </h3>

      <div className={styles.row}>
        <span style={{ width: '7vw' }}>-</span>
        <div className={styles.teamGoal}>
          <b>קבוצה</b>
        </div>
        <div className={styles.scorerGoal}>
          <b>מבקיע</b>
        </div>
        <div className={styles.asisterGoal}>
          <b>מבשל</b>
        </div>
      </div>

      {match.goals_list?.map(goal => (
        <div
          className={`${styles.row} ${styles.rowGoal}`}
          key={goal.id}
          onClick={() => handleShowDeleteGoalModal(goal)}
        >
          <img className={styles.imgGoal} src={GoalGate} alt="שער" />
          <div className={styles.teamGoal}>
            <b>{teamName(goal.by_team)}</b>
          </div>
          <div className={styles.scorerGoal}>
            {showPlayerName(goal, goal.scorer)}
          </div>
          <div className={styles.asisterGoal}>
            {showPlayerName(goal, goal.assist)}
          </div>
        </div>
      ))}

      <h3>כרטיסים ירוקים במשחק</h3>
      <div className={styles.greensCards}>
        <div className={`${styles.row} ${styles.rowGreen}`}>
          <img src={GreenCard} alt="כרטיס ירוק" />
          <div>
            {match.teams[0].name}:{' '}
            {match.teams[0].green_cards === undefined
              ? 0
              : match.teams[0].green_cards}
          </div>
        </div>

        <div className={`${styles.row} ${styles.rowGreen}`}>
          <img src={GreenCard} alt="כרטיס ירוק" />
          {match.teams[1].name}:{' '}
          {match.teams[1].green_cards === undefined
            ? 0
            : match.teams[1].green_cards}
        </div>
      </div>

      {/* Delete goal modal */}
      {deletedGoal && (
        <FuncModal
          topic={'מחיקת שער'}
          info={'האם אתה בטוח שברצונך למחוק את גול זה?'}
          goalinfo={`קבוצת ${teamName(
            deletedGoal.by_team
          )} | מבקיע: ${showPlayerName(
            deletedGoal,
            deletedGoal.scorer
          )} | מבשל: ${showPlayerName(deletedGoal, deletedGoal.assist)}`}
          //textCancel={'לא למחוק'}
          //textOK={'אפשר למחוק'}
          funcClose={handleCloseDeleteGoalModal}
          funcCancel={handleCloseDeleteGoalModal}
          funcAgree={handleDeleteGoal}
        />
      )}
    </div>
  );
}

export default MatchSum;
